import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { SettingsService } from '../../services/settings/settings.service';
import { DataService } from '../../services/data/data.service';

import _ from 'lodash';

@Component({
	selector: 'pcm-user-config',
	templateUrl: './user-config.component.html',
	styleUrls: ['./user-config.component.scss']
})
export class UserConfigComponent implements OnInit, OnDestroy {

	configs = [];
	userSettings = {
		countryFilters: [],
		divisionFilters: [],
		costCenterFilters: [],
		notificationConfigs: []
	};

	/* since we modify the userSettings object to render combo boxes, we will save modified object into this originalUserSettings to check for unsaved changes */
    originalUserSettings = {
        countryFilters: [],
        divisionFilters: [],
        costCenterFilters: [],
        notificationConfigs: []
    };

	userSettingsListener;

	constructor(
		public configService: ConfigService,
		public settingsService: SettingsService,
		private dataService: DataService

	) { }

	ngOnInit() {
		this.settingsService.loadUserSettings();
		this.userSettingsListener = this.dataService.userSettingsListener().subscribe((event) => {
			this.userSettings = _.cloneDeep(this.dataService.userSettings);
			this.setUpData('countryFilters', 'countrycode');
			this.setUpData('divisionFilters', 'divisioncode');
			this.setUpData('costCenterFilters', 'costcenter');
			this.originalUserSettings = _.cloneDeep(this.userSettings)
		});
	}

	ngOnDestroy() {
		this.userSettingsListener.unsubscribe();
	}

	onCheckAll(filterType) {
		const filterArray = [...this.userSettings[filterType]];

		filterArray.forEach(filter => {
			filter.selected = true;
		});

		this.userSettings[filterType] = filterArray;
	}

	submitConfigs() {
		this.updateSubmitData('countryFilters', 'countrycode');
		this.updateSubmitData('divisionFilters', 'divisioncode');
		this.updateSubmitData('costCenterFilters', 'costcenter');
		this.settingsService.submitConfigs(this.userSettings);
	}

	hasChanges() {
		return _.isEqual(this.userSettings, this.originalUserSettings);
	}

	/**
	 * updates selected items in the combo box to be subscribed
	 * @param event list of selected combo-box items
	 * @param filterType filter category
	 */
	updateSelected(event, filterType) {
		this.userSettings[filterType].forEach((item: any) => {
			if (event.some(selectedItem => selectedItem.content === item.content)) {
				item.selected = true;
			} else {
				item.selected = false;
			}
		});
	}

	/**
	 * sets up user settings to be correctly formatted for combo-box
	 * @param filterType filter category 
	 * @param propName filter code
	 */
	setUpData(filterType, propName) {
		this.userSettings[filterType] = this.userSettings[filterType].map(filter => {
			return {
				id: filter.id,
				type: filter.type,
				content: filter[propName],
				selected: !!filter.subscribed
			};
		});
	}

	/**
	 * transition user settings from combo-box format back to original format
	 * @param filterType filter category
	 * @param propName filter code
	 */
	updateSubmitData(filterType, propName) {
		this.userSettings[filterType] = this.userSettings[filterType].map(filter => {
			return {
				id: filter.id,
				type: filter.type,
				[propName]: filter.content,
				subscribed: !!filter.selected
			};
		});
	}
}
